export default __webpack_public_path__ + "static/media/AltCopyBlue.9678311f.svg";